export default "__VITE_ASSET__639bbfd7__"